/* eslint-disable */
import React, { memo, useEffect, useState } from 'react'
import _ from 'lodash'
import { Grid, TextField } from '@material-ui/core'
import { Controller } from 'react-hook-form'
import asterisk from 'assets/img/asterisk.svg'

import * as Style from './styles'
import RegisterInput, { CellPhoneMaskCustom } from 'components/RegisterInput'
import { useTranslation } from 'react-i18next'
import { VerifyPhone } from '../../../../redux/api/location'
import { ValidateEmail } from '../../helpers/validation'
import {
    CellPhoneIsValid,
    EmailIsValid,
} from '../PersonalData/helpers/errorsTreatment'
import { GetThemeColorFromStorage } from '../../../../redux/api/themeColor'
import { Asterisk } from '../../../../assets/icons_svg'
import { Box, Typography } from '@mui/material'

const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i

function ContactData({
    errors,
    control,
    watch,
    setError,
    preDisabled,
    setValue,
    clearErrors,
    disableItems,
}) {
    const { t } = useTranslation()
    const [timerStarted, setTimerStarted] = useState(false)
    const [themeColor, setThemeColor] = useState(GetThemeColorFromStorage())
    const [phoneNumber2Error, setPhoneNumber2Error] = useState('')

    useEffect(() => {
        if (watch('phoneNumber2')?.replace(/[^\d]+/g, '')?.length > 10) {
            const x = watch('phoneNumber2')?.replace(/[^\d]+/g, '')
            VerifyPhone(x).then((res) => {
                if (res.success === false && res?.errors?.length > 0) {
                    const data = res?.errors[0]
                    setError('phoneNumber2', {
                        type: 'manual',
                        message: t(data?.message),
                    })
                    setPhoneNumber2Error(t(data?.message))
                }
            })
        }
    }, [watch('phoneNumber2')])

    useEffect(() => {
        if (!_.isEmpty(watch('email'))) {
            if (regex.test(watch('email'))) EmailValidate(watch('email'))
        }
    }, [watch('email')])

    const EmailValidate = async (email) => {
        try {
            const res = await ValidateEmail(email)

            if (res === false) {
                setError('email', {
                    type: 'manual',
                    message: t('email - DUPLICATED'),
                })
            }
        } catch (error) {
            console.log(error)
        }
    }

    const DisableEmailOrPhoneNumber2 = (type) => {
        if (preDisabled) {
            if (type === 1) {
                if (
                    watch('phoneNumber2Pre') !== watch('phoneNumber2') &&
                    _.isEmpty(watch('emailPre')) === false
                ) {
                    return true
                }
            }
            if (type === 2) {
                if (
                    watch('emailPre') !== watch('email') &&
                    _.isEmpty(watch('phoneNumber2Pre')) === false
                ) {
                    return true
                }
            }
        }

        return false
    }

    const handleKeyUp = () => {
        if (!timerStarted) {
            setTimerStarted(true)
        }
    }

    useEffect(() => {
        let typingTimer

        if (preDisabled) {
            if (!timerStarted) {
                setTimerStarted(true)
            }

            clearTimeout(typingTimer)
            typingTimer = setTimeout(() => {
                let email = watch('email') || ''

                if (!_.isEmpty(watch('emailPre')) && _.isEmpty(email)) {
                    setValue('email', watch('emailPre'))
                    clearErrors('email')
                }
                if (
                    !_.isEmpty(watch('phoneNumber2Pre')) &&
                    _.isEmpty(watch('phoneNumber2'))
                ) {
                    setValue('phoneNumber2', watch('phoneNumber2Pre'))
                    clearErrors('phoneNumber2')
                    setPhoneNumber2Error(null)
                }
            }, 3000)
        }

        return () => clearTimeout(typingTimer)
    }, [watch('email'), watch('phoneNumber2')])

    return (
        <Style.Container container xs={12} spacing={2} alignItems="flex-start">
            <Grid
                item
                container
                xs={12}
                md={8}
                alignItems="center"
                style={{ marginTop: '-2.5px' }}
            >
                <Controller
                    as={
                        <RegisterInput
                            label="E-mail"
                            disabled={
                                DisableEmailOrPhoneNumber2(1) ||
                                disableItems?.phone
                            }
                            xs={12}
                            inputProps={{
                                autoComplete: 'new-password',
                            }}
                            onKeyUp={handleKeyUp}
                            error={!!errors?.email}
                            helperText={t(errors?.email?.message)}
                        />
                    }
                    name="email"
                    control={control}
                    id="email"
                />
            </Grid>
            <Controller
                render={({ value, onChange }) => (
                    <RegisterInput
                        onChange={(e) => {
                            onChange(e)
                            setPhoneNumber2Error(null)
                        }}
                        value={value}
                        label={t('FIELD_REGISTER_MOBILE_PHONE')}
                        xs={12}
                        md={4}
                        disabled={
                            DisableEmailOrPhoneNumber2(2) || disableItems?.email
                        }
                        onKeyUp={handleKeyUp}
                        error={!!errors.phoneNumber2 || phoneNumber2Error}
                        helperText={t(errors?.phoneNumber2?.message || phoneNumber2Error)}
                        InputProps={{
                            inputComponent: CellPhoneMaskCustom,
                        }}
                    />
                )}
                name="phoneNumber2"
                control={control}
                id="phoneNumber2"
            />
            <Grid
                item
                container
                xs={12}
                md={12}
                alignItems="center"
                style={{ marginTop: '-2.5px' }}
            >
                <Style.CustomAlert
                    sx={{
                        gap: "10px",
                        display: "flex",
                        padding: "4px 10px",
                        alignItems: "center",
                        backgroundColor: "#F2F2F2",
                        borderRadius: "4px",
                    }}
                >
                    <Box
                        component="i"
                        className='icon-alerta'
                        sx={{
                            color: '#FFA200',
                        }}
                    />
                    <Typography
                        variant='body1'
                        fontSize={{
                            xs: '9px',
                            sm: '10px',
                            md: "12px"
                        }}
                        color="#333333"
                        fontStyle="italic"
                    >
                        {t('IT_IS_IMPORTANT_TO_FILL_IN_EMAIL')}
                    </Typography>
                </Style.CustomAlert>
            </Grid>
            <Controller
                as={<TextField style={{ display: 'none' }} />}
                name="emailPre"
                control={control}
                id="emailPre"
            />
            <Controller
                as={<TextField style={{ display: 'none' }} />}
                name="phoneNumber2Pre"
                control={control}
                id="phoneNumber2Pre"
            />
        </Style.Container>
    )
}

export default memo(ContactData)
